module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6n8n7n-8bc518b27db429751211b9ca48eeb30d.svg";